module.exports = __webpack_public_path__ + "8765ce17323f465a7de4e77d3a5944d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/PrintTypes/sublimation.jpg
// module id = 870
// module chunks = 1